import React, { useEffect, useRef } from 'react';
import { IErrorListProps } from './types';
import { Alert } from 'react-bootstrap';
import styles from './ErrorList.module.css';

const ErrorList: React.FC<IErrorListProps> = ({ className, errors }) => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (errors && errors.length > 0 && elementRef.current) {
      elementRef.current.scrollIntoView();
    }
  }, [errors]);

  if (errors.length === 0) return null;

  return (
    <Alert variant="danger" ref={elementRef}>
      <ul className={`${styles.list} ${className}`}>
        {errors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </Alert>
  );
};

export default ErrorList;
